import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  content: {
    display: 'inline-block',
    color: '#666666',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },
}));
